import { generatePath } from 'react-router';

import { DRIVE_PAGE } from '@/common/constants/pages';
import { DriveContainerId } from '@/drive/entities/DriveItemId';

export function getDriveFolderUrl(id: DriveContainerId): string {
  return generatePath(DRIVE_PAGE, { section: id?.toString() ?? null });
}
